module.exports = __webpack_public_path__ + "media/images/home/marketposters_logo_____-8ab9934799477b32ecfe4c5d115e0a5a.png";